module.exports = __webpack_public_path__ + "static/assets/reece-icon.svg";